import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { User } from "../../shared/interfaces/user";
import { inject } from "@angular/core";
import { AuthService } from "../../auth.service";

export const matchResolver: ResolveFn<User> = (route: ActivatedRouteSnapshot) => {
    const id = parseInt(route.params['id'])
    return inject(AuthService).getProfile(id)
}